import React, { useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate, useSearchParams, Route, Routes } from 'react-router-dom'
import Profile from '../../components/Profile'
import '../../styles/css/Karyawan.css'
import searchIcon from '../../assets/icons/search-icon.svg'
import calenderIcon from '../../assets/icons/arrow-right.svg'
import { useDispatch, useSelector } from 'react-redux'
import Sidebar from '../../components/sidebar/Sidebar'
import {
    getJurnalSiswa,
    updateStateJurnalSiswa,
    setCurrentKategoriJurnalSiswa,
    setKategoriIdJurnalSiswa,
} from '../../features/jurnalSiswaSlice'
import LoadingTable from '../../components/LoadingTable'
import PilihTanggal from '../../components/jurnal/PilihTanggal'
import Tabbar from '../../components/Tabbar'
import Table from '../../components/jurnal-siswa/Table'

const PRIMARY = '#3661EB'

const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

function JurnalSiswa() {
    const {
        listTabbar,
        loading,
        search,
        startText, endText,
        startTime, endTime,
        kelas
    } = useSelector(state => state.jurnalSiswa)

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(null)

    // Navigate to default tab on first load
    useEffect(() => {
        if (location.pathname === '/jurnalsiswa' && listTabbar.length > 0) {
            navigate(`/jurnalsiswa/${listTabbar[0].kategori}`);
        }
    }, [location.pathname, listTabbar, navigate])

    // Initial data fetch
    useEffect(() => {
        const urlSearch = searchParams.get('search')
        const urlStartTime = searchParams.get('start_time')
        const urlEndTime = searchParams.get('end_time')

        dispatch(getJurnalSiswa({
            search: urlSearch || '',
            start_time: urlStartTime || startTime,
            end_time: urlEndTime || endTime,
        }))

        if (urlSearch) dispatch(updateStateJurnalSiswa({ name: 'search', value: urlSearch }))
    }, [])

    function handleSearch() {
        dispatch(getJurnalSiswa({ start_time: startTime, end_time: endTime, search }))
        dispatch(updateStateJurnalSiswa({ name: 'currentPage', value: 1 }))
        setSearchParams({
            search: search || '',
            start_time: startTime || '',
            end_time: endTime || '',
        })
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') handleSearch()
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar />
            <div className='karyawan'>

                <div className='search-and-profile'>
                    <div className='wrap-search'></div>
                    <Profile />
                </div>

                <div className='title-btn'>
                    <h1>Jurnal SiswaJ</h1>

                    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '10px', width: 500 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 300 }}>
                            <span style={{ color: GREY, fontSize: 14 }}>🔍</span>
                            <input
                                type="text"
                                placeholder="Cari guru"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStateJurnalSiswa({ name: 'search', value: e.target.value }))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>

                        <div className='search-and-profile' style={{ marginBottom: 0 }}>
                            <div className='wrap-search'>
                                <div className='wrapper-pilih-tanggal' style={{ marginRight: 0 }}>
                                    <style>{`
.btn-pilih-tanggal {
border: 1px solid ${BORDER};
border-radius: 10px;
}

.pilih-tanggal {
border: none !important;
}


  `}</style>
                                    <PilihTanggal
                                        text={startText}
                                        setText={updateStateJurnalSiswa}
                                        stateText='startText'
                                        setDate={setStartDate}
                                        date={startDate}
                                        setTime={updateStateJurnalSiswa}
                                        stateTime='startTime'
                                    />
                                    <img src={calenderIcon} alt="" />
                                    <PilihTanggal
                                        text={endText}
                                        setText={updateStateJurnalSiswa}
                                        stateText='endText'
                                        setDate={setEndDate}
                                        date={endDate}
                                        setTime={updateStateJurnalSiswa}
                                        stateTime='endTime'
                                    />
                                </div>
                            </div>
                        </div>

                        <button
                            className='btn-search'
                            style={{ background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48 }}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt="" />
                        </button>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                    <div style={{
                        background: 'rgba(54,97,235,0.1)', border: '1px solid rgba(54,97,235,0.35)',
                        borderRadius: 100, padding: '6px 14px', display: 'inline-flex', alignItems: 'center',
                    }}>
                        <span style={{ fontSize: 10, fontWeight: 600, color: PRIMARY }}>Kelas {kelas ?? "-"}</span>
                    </div>
                </div>

                <div className='tabbar-filter'>
                    <Tabbar
                        options={listTabbar}
                        setKategoriId={setKategoriIdJurnalSiswa}
                        setCurrentKategori={setCurrentKategoriJurnalSiswa}
                        setKeterangan={updateStateJurnalSiswa}
                        searchParams={''}
                        path='/jurnalsiswa'
                        loading={false}
                    />
                </div>

                {loading
                    ? <LoadingTable size={'large'} />
                    : <Routes>
                        {listTabbar.map((item, index) => (
                            <Route key={index} path={`/${item.kategori}`} element={<Table />} />
                        ))}
                    </Routes>
                }
            </div>
        </div>
    )
}

export default JurnalSiswa
